import { Injectable } from '@angular/core';
import { ReceiptType } from '@checkout/const';
import { BaseStoreFacade } from '@city/data-access';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutActions } from '../store/actions/';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ReceiptTypeFacade {
  constructor(
    private store: Store<StateWithCustomCheckout>,
    protected baseStores: BaseStoreFacade,
  ) {}

  loadReceiptTypes(): void {
    this.store.dispatch(new CheckoutActions.LoadReceiptType());
  }

  resetReceiptTypes(): void {
    this.store.dispatch(new CheckoutActions.ResetReceiptType());
  }

  getReceiptTypes(): Observable<ReceiptType[]> {
    return this.store.pipe(select(CheckoutSelectors.getReceiptTypes));
  }

  setActiveReceiptType(mode: string): void {
    this.store.dispatch(new CheckoutActions.SetReceiptType(mode));
  }

  resetActiveReceiptType(): void {
    this.store.dispatch(new CheckoutActions.ResetActiveMode());
  }

  getActiveReceiptType(): Observable<ReceiptType> {
    return combineLatest([this.getReceiptTypes(), this.getActiveReceiptTypeId()]).pipe(
      map(([modes, id]: [ReceiptType[], string]) => modes?.find((mode: ReceiptType) => mode.code === id)),
    );
  }

  getActiveReceiptTypeId(): Observable<string> {
    return this.store.pipe(select(CheckoutSelectors.getActiveReceiptType));
  }
}
